var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{attrs:{"visible":_vm.drawer,"title":_vm.titulo},on:{"update:visible":function($event){_vm.drawer=$event}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }